export type BreezSdkInstance = Awaited<
  ReturnType<typeof import('@breeztech/breez-sdk-spark').connect>
>;

let breezSdkInstance: BreezSdkInstance | null = null;

export const setBreezSdk = (sdk: BreezSdkInstance | null): void => {
  breezSdkInstance = sdk;
};

export const getBreezSdk = (): BreezSdkInstance | null => breezSdkInstance;

let identityPubkey: string | undefined = undefined;

export const setIdentityPubkey = (pubkey: string | undefined): void => {
  identityPubkey = pubkey;
};

export const getIdentityPubkey = (): string | undefined => identityPubkey;